module.exports = __webpack_public_path__ + "img/hezuo.b8d82c99.png";